import { render, staticRenderFns } from "./schaeffler-belts.vue?vue&type=template&id=d2277e1e&"
import script from "./schaeffler-belts.vue?vue&type=script&lang=js&"
export * from "./schaeffler-belts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports